import styles from "./PaymentMethod.module.scss";
import emptyIcon from "../../../assets/images/icons/payment-empty.svg";
import { useTranslation } from "react-i18next";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import plusIcon from "../../../assets/images/icons/plus.svg";

const PaymentMethodEmpty = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const clickOnAddNewCard = () => {
    navigate("/settings/billing/cards/new");
  };

  return (
    <div className={styles.container}>
      <img className={styles.image} src={emptyIcon} alt={"empty"} />
      <h3 className={styles.title}>{t("YouHaveNoCardsAvailable")}</h3>
      <div className={styles.btnWrapper}>
        <CustomButton
          text={t("AddNewCard")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={clickOnAddNewCard}
          icon={plusIcon}
          altIcon={"plus"}
        />
      </div>
    </div>
  );
};

export default PaymentMethodEmpty;
